Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isPromise;
// to support Promise-like object.
function isPromise(value) {
    return value && typeof value.then === "function";
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-metrics/lib/core/utils/isPromise.js
// module id = 1057
// module chunks = 31